export default __webpack_public_path__ + "static/im_hero_768-6c83d57956ec1c229de4320987654b55.png";